import { render } from "./BackCabinetBtn.vue?vue&type=template&id=b4ab1a7e&scoped=true"
import script from "./BackCabinetBtn.vue?vue&type=script&lang=js"
export * from "./BackCabinetBtn.vue?vue&type=script&lang=js"

import "./BackCabinetBtn.vue?vue&type=style&index=0&id=b4ab1a7e&lang=scss&scoped=true"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4ab1a7e"]])

export default __exports__